<template>
  <div class= "about-page">

   <div class = "img-sanwo-header">
     <p class = "aboutss" style = "font-size: 30px;">Sanwo e</p>
      <p class = "aboutss">


         Introducing Sanwo'e, a mobile app ticketing for smart transport system in Lagos.
          The software connect commuters real-time to buses route & travel info, connect transport systems to commuters via general info & engagement, finally connect commuters to fast & better mode of ticketing across multi modal transport infrastructure.
           
        </p>
        <br />



      

    </div>
    <div class = "sanwo-content">

    <p style="color: #000">
      The value preposition to transport stakeholders includes better service delivery, greater revenue & profits, improved environmental footprint, data & analytics. For commuters better customers experience, smart payment solution, real-time communication & info on travel and travel convenience.
          For govt and agency, it's include actionable insight, smart transport infrastructure design, value chain in ICT, scalable & profitable by design
      </p>



                      <router-link :to="{ name: 'Contact' }">

         <a class="btn btn-new btn-xl js-scroll-trigger" href="#services"
                style = "background-color: #A31B1F ; color : #FFFFFF"
                
                >Learn more</a
              > 
                      </router-link>
        
    </div>

</div>
</template>

<style>
.about-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.about{
display: flex;
  align-items: center;
  justify-content: center;
font: normal normal normal 24px/35px Prompt;font: normal normal normal 16px/35px Prompt;
font-weight: bold;
width: 50vw;
letter-spacing: 0px;
color: #FFFFFF;
opacity: 1;
}
#para {
  color: #2D2D2D
}

.sanwo-content {
  margin-top: 80px;
   padding: 0 200px 0 200px;
   color: #000 !important;
   text-align: center;
}


.brand-area {
        display: flex;
        justify-content: center;
    }
.img-sanwo-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 45px;
  justify-content: center;
  align-items: center;
  height: 700px;    
  background-attachment: fixed;
  background-position: center; 
  position: relative;
  background-repeat: no-repeat;
  background: linear-gradient( rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6) ), url('../assets/img/Sanwo.png'); 
    background-size: cover;
}

.mission{
  width: 450px;
  padding: 15px;
  color: #2D2D2D;
  font-size: 16px;
  height:   200px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 8px 24px #0000000D;
border-radius: 15px;
opacity: 1;
display: flex;
align-items: center;
flex-direction: column;
justify-content: center;

}
.business{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  padding: 70px;
  color: #2D2D2D;
  font-size: 16px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 8px 24px #0000000D;
border-radius: 15px;
opacity: 1;
height: 185px;
text-align: center;

}

.touch{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 15px;
  width: 90vw;
  color: #2D2D2D;
  font-size: 16px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 8px 24px #0000000D;
border-radius: 15px;
opacity: 1;
height: 185px;
text-align: center;

}

footer {
  width:100vw
}
body {
  background: black;
}
</style>

<script>
    import router from '../router'

    export default {
        name: 'Sanwo',
        methods: {
            navigate() {
                router.push({ name: "Sanwo" });
            }
        }
    }
</script>

